// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__FilQC","page":"pagination_page__iDpdg","disabled":"pagination_disabled__l+sCq","currentPage":"pagination_currentPage__2FVSG"};